<script>
export default {
  name: 'FundraiserPageRaisedAmount',
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    }
  },
  computed: {
    textSizeRaisedAmount() {
      return 'text-5xl'
    },
  }
}
</script>

<template>
  <div class="flex flex-wrap gap-2 justify-between items-end mb-2">
    <h2 class="text-amber-500 text-3xl md:text-4xl lg:text-3xl font-semibold">
      ${{ fundraiserPage.cached.raised_formatted }}
    </h2>
    <span class="text-sm md:text-lg lg:text-sm font-sans font-semibold mb-[2px]">
      {{ fundraiserPage.cached.percentage_raised }}% of ${{ fundraiserPage.goal_formatted }} goal
    </span>
 </div>
</template>

<style scoped>

</style>
